import type { ImageSourcePropType } from "react-native";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import EmptyState from "../EmptyView";
import ScrollContainer from "../ScrollContainer";
import ProgressView from "./ProgressView";
/* -----------------Assets--------------- */
import ProgressEmptySvg from "./progress-empty-state.svg";
import type {
	ExamCardData,
	MasteryTagProgressData,
	SummaryCardData,
} from "./types";

const ProgressApplet = ({
	showPracticeTests,
	handleClickCard,
	showStudyPackViews,
	handleClickStudy,
	appFont,
	handleNavigation,
	progressNeedsImprovementCtaLabel,
	emptyState,
	masteryTagsProgressData,
	needsImprovementProgressData,
	progressPageSummaryCardData,
	practiceTestsCardsData,
	showEmptyState,
	weakTagIds,
	handleClickInfo,
	renderNestedExamChips,
}: {
	showPracticeTests?: boolean;
	handleClickCard: (title: string) => void;
	showStudyPackViews?: boolean;
	handleClickStudy: (tagIds: string[]) => void;
	appFont: string;
	handleNavigation: (numericId: number) => void;
	progressNeedsImprovementCtaLabel: string;
	emptyState: {
		title: string;
		subtitle: string;
		cta: string;
		onAction?: () => void;
	};
	masteryTagsProgressData: MasteryTagProgressData[];
	needsImprovementProgressData: MasteryTagProgressData | null;
	progressPageSummaryCardData?: SummaryCardData;
	practiceTestsCardsData?: ExamCardData;
	showEmptyState: boolean;
	handleClickInfo: (text: string, title: string) => void;
	weakTagIds: string[];
	renderNestedExamChips: () => React.ReactNode;
}) => {
	const { isMobile } = useDevice();
	return (
		<ScrollContainer
			maxWidth="sm"
			// biome-ignore lint/a11y/useSemanticElements: <explanation>
			role="main"
			contentContainerStyle={{
				paddingVertical: isMobile ? 16 : 24,
			}}
		>
			{renderNestedExamChips?.()}
			{showEmptyState ? (
				<EmptyState
					title={emptyState.title}
					subtitle={emptyState.subtitle}
					cta={emptyState.cta}
					image={ProgressEmptySvg as ImageSourcePropType}
					handleAction={emptyState.onAction}
				/>
			) : (
				<Box paddingHorizontal={isMobile ? 16 : 0}>
					<ProgressView
						masteryTagsProgressData={masteryTagsProgressData}
						needsImprovementProgressData={needsImprovementProgressData}
						summaryCardData={progressPageSummaryCardData}
						practiceTestsCardData={practiceTestsCardsData}
						showStudyPackViews={showStudyPackViews}
						showPracticeTests={showPracticeTests}
						handleClickCard={handleClickCard}
						handleClickStudy={() => handleClickStudy(weakTagIds)}
						appFont={appFont}
						handleNavigation={handleNavigation}
						progressNeedsImprovementCtaLabel={progressNeedsImprovementCtaLabel}
						handleClickInfo={handleClickInfo}
					/>
				</Box>
			)}
		</ScrollContainer>
	);
};

export default ProgressApplet;
